import { LayoutDashboard, Network, ShieldCheck, type LucideIcon } from 'lucide-react';

export type SectionId = 'overview' | 'investigate' | 'respond';

export interface ConsoleSection {
  id: SectionId;
  label: string;
  /** The `id` of the element the console renders for this section. */
  anchor: string;
  icon: LucideIcon;
}

/** The console's sections, top to bottom. The top bar scrolls to them and marks the one in view. */
export const SECTIONS: readonly ConsoleSection[] = [
  { id: 'overview', label: 'Overview', anchor: 'c3-overview', icon: LayoutDashboard },
  { id: 'investigate', label: 'Investigate', anchor: 'c3-investigation-workspace', icon: Network },
  { id: 'respond', label: 'Threats', anchor: 'c3-threat-feed', icon: ShieldCheck },
];

/** `#respond`: how another view asks the console to open on a section. */
export function sectionHash(id: SectionId): string {
  return `#${id}`;
}

export function sectionFromHash(hash: string): ConsoleSection | null {
  const id = hash.replace(/^#/, '');
  return SECTIONS.find((section) => section.id === id) ?? null;
}
